<template>
    <a
            class="purchase-option-group"
            :class="purchaseOptionClasses"
            href="#!"
            @click="selectedHandler"
    >
        <div>
            <div class="group-container">
                <div class="plan-container" v-if="subscriptionPlan && !promotionalCode">
                    <Plan
                            :showCurrency="showCurrency"
                            :subscriptionPlan="subscriptionPlan"
                            :active="selected"
                    />
                </div>
                <div class="promo-container" v-if="promotionalCode">
                    <Promo
                            :promotionalCode="promotionalCode"
                            :active="selected"
                    />
                </div>
                <!--<div
                        class="payment-methods-wrapper"
                        v-if="subscriptionPlan && subscriptionPlan.payment_methods"
                >
                    <div
                            class="payment-method"
                            v-for="paymentMethod in subscriptionPlan.payment_methods.data"
                            :key="paymentMethod.id"
                            :style="{backgroundImage: `url('${paymentMethod.image_url}')`}"
                            :title="paymentMethod.name"
                    >
                    </div>
                </div>-->
            </div>
        </div>
    </a>
</template>
<script>
    import Plan from './SubscriptionForm.Plan';
    import Promo from './SubscriptionForm.Promo';

    export default {
        components: {
            Plan,
            Promo,
        },
        props: {
            purchaseOption: {
                type: Object,
                required: true,
            },
            showCurrency: {
                required: true,
            },
            selected: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            selectedHandler(){
                this.$emit('selected', this.purchaseOption);
            },
        },
        computed: {
            promotionalCode(){
                return this.purchaseOption.promotional_code ? this.purchaseOption.promotional_code.data : null;
            },
            subscriptionPlan(){
                return this.purchaseOption.subscription_plan ? this.purchaseOption.subscription_plan.data : null;
            },
            hasBoth(){
                return this.promotionalCode && this.subscriptionPlan;
            },
            purchaseOptionClasses(){
                return {
                    'free-trial': this.promotionalCode && !!this.promotionalCode.type_is_free_trial,
                    'has-both': this.hasBoth,
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    @import './../styles/variables';

    .purchase-option-group{

        .group-container{
            margin-bottom: 15px;
            position: relative;
        }

        /*
        .payment-methods-wrapper{
            pointer-events:none;
            position: absolute;
            height: 100%;
            right: 0;
            bottom: 0;
            top: 0;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-end;

            @media(max-width: 600px) {
                display:none;
            }


            .payment-method{
                width: 40px;
                height: 40px;
                box-shadow: 1px 1px 4px rgba(0,0,0,.35);
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                background-color: $pallete_secondary_color;

                &:not(:first-child){
                    margin-top: 7.5px;
                }
            }
        }
        */
    }
</style>